module.exports = __webpack_public_path__ + "static/sketch-retina@2x-38128008ad3ed9a0dc8aaff6a388d7e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketch/sketch-retina@2x.jpg
// module id = 452
// module chunks = 131293461488081 145262073310797 281043220932899